// @ts-check
import React from 'react';
import classNames from 'classnames';

import './RedBar.scss';

/** @type {import('~/types/React').ReactFC<{}, HTMLDivElement>} */
const RedBar = ({ ...rest }) => {
	return <div {...rest} className={classNames(rest.className, 'red-bar')} />;
};

export default RedBar;
